import config from "../config";

const REL_TOKEN_ORDER = ["noopener", "noreferrer", "sponsored", "nofollow"];

const normalizeBrandName = value =>
  String(value || "")
    .trim()
    .toLowerCase();

const normalizeRelTokens = rel =>
  String(rel || "")
    .split(/\s+/)
    .map(token => token.trim())
    .filter(Boolean);

const dedupeTokens = tokens => [...new Set(tokens)];

const formatRelTokens = tokens =>
  REL_TOKEN_ORDER.filter(token => tokens.includes(token)).join(" ");

export const isApprovedRelBrand = brand => {
  const approvedBrands = config.linkRelApprovedBrands || [];
  const normalizedBrand = normalizeBrandName(brand);

  if (!normalizedBrand) {
    return false;
  }

  return approvedBrands.some(approvedBrand => {
    const normalizedApprovedBrand = normalizeBrandName(approvedBrand);
    return normalizedBrand === normalizedApprovedBrand;
  });
};

export const getOutboundLinkRel = ({
  brand,
  rel = "noopener noreferrer sponsored"
} = {}) => {
  const tokens = normalizeRelTokens(rel);

  if (isApprovedRelBrand(brand)) {
    return formatRelTokens(
      dedupeTokens(tokens.filter(token => token !== "sponsored" && token !== "nofollow"))
    );
  }

  return formatRelTokens(dedupeTokens(tokens));
};